var StepNames = /* @__PURE__ */ ((StepNames2) => {
  StepNames2["Login"] = "login";
  StepNames2["Shipping"] = "shipping";
  StepNames2["Overview"] = "overview";
  StepNames2["Payment"] = "payment";
  return StepNames2;
})(StepNames || {});
export {
  StepNames
};
//# sourceMappingURL=shared.js.map
